import React, { useState, useContext, useEffect, forwardRef } from 'react';
import { BiChevronUp } from 'react-icons/bi';
import { FaCheck } from 'react-icons/fa';
import { ForwardFittingContext } from "../../ForewardFitting/ForwardFittingContext";
import { FaArrowsAltV, FaArrowsAltH } from "react-icons/fa";
import StickImage from "../../../assets/images/stick_image.png";
import StickSvg from '../SvgData/StickSvg';
import { Form } from 'react-bootstrap';
import { MdRemoveRedEye, MdCheck } from "react-icons/md";
import { FaTimesCircle } from "react-icons/fa";
import { Modal, ProgressBar } from 'react-bootstrap';
import './progessbar.css'
import { ImCross } from "react-icons/im";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CameraModal from "../ImageUpload/CameraModel.js";



const IronsDatacamera = forwardRef(({ step, iron, title, options, number, shotOpction, shortStrike, options2, activeEyes,borderClass }, ref) => {


    const { remotefittingdata, setRemotefittingdata, updateremotefitting, remotefittingimage, setRemotefittingimage, updateremotefittingfile } = useContext(ForwardFittingContext);

    const [photoInBox, setPhotoInBox] = useState([null, null, null]);
    const [imageURL, setImageURL] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [activeIronIndex, setActiveIronIndex] = useState(null); 

    const handleOpenModal = (index) => {
        setActiveIronIndex(index);
        setShowModal(true);
    };
 
    const handleCloseModal = () => {
        setShowModal(false);
        console.log("close modal");
    }
    // Function to update the specific photo box with the captured image
    const updatePhotoInBox = (imageSrc) => {
        if (activeIronIndex !== null) { 
            updateremotefittingfile(step + "." + iron + '.cameraimage', imageSrc);
            setImageURL(imageSrc);
            handleCloseModal(); // Close the modal
        }
    };

    const [isMobile, setIsMobile] = useState(true);
    const checkDevice = () => {
        setIsMobile(window.innerWidth <= 500); // You can adjust the width value as per your needs
    };


    useEffect(() => {
        checkDevice();

        const squareDivs = document.querySelectorAll('.drop_box');
        console.log('drop-box-camera', squareDivs);

        squareDivs.forEach((squareDiv) => {
            // Get the width of each div
            const divWidth = squareDiv.offsetWidth;
           // setHeight(divWidth); // Assuming setHeight is a valid function in your context

            // Set the height to match the width (making it square)
            squareDiv.style.height = divWidth + 'px';
            console.log('Div width:', divWidth);
        });
        window.addEventListener("resize", checkDevice);
        return () => {
            window.removeEventListener("resize", checkDevice);
        };
    }, []); 

    useEffect(() => {
        const cameraImage = remotefittingimage[step][iron]?.cameraimage;

        if (cameraImage && cameraImage.startsWith("data:image/")) {
            setImageURL(cameraImage); // Use the base64 image directly
        } else {
            // Reset imageURL if no valid image is found for the current step
            setImageURL(null);
        }
    }, [step, remotefittingimage]);



    window.addEventListener('load', function () {
        // setWidth(window.innerWidth);

        // Get all divs with the class name 'drop_box'

    });

    return (
        <>
            <div className="">
                <div className="">
                    <div className="">
                        <div className="">
                            <div className="">
                                <div className="">
                                    <div className="new-design-border-sec">
                                        <div className="bg_color_dark">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="justify-content-center">

                                                        {/* Box 1 */}
                                                        <div className="">
                                                            <div className="sec-header-dash border-header-sec white">
                                                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                    <h3 className="box-title-lable">
                                                                        <span className="color">{number}</span> {title}
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            <div className="desc">
                                                                <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                                            </div>
                                                            <div className="card-video" style={{ width: "100%" }}>
                                                                <div className={`drop-box-camera ${borderClass ? borderClass : 'drop_box'}`} onClick={() => handleOpenModal(0)}>
                                                                    <input
                                                                        type="file"
                                                                        accept=".mp4,.avi,.mkv"
                                                                        id={`swing1.fileID`}
                                                                        style={{ display: 'none' }}
                                                                    />
                                                                    {
                                                                        imageURL && (
                                                                            <div className="form">
                                                                                <img
                                                                                    className='uploaded-image' 
                                                                                     key={imageURL}
                                                                                    src={imageURL}
                                                                                    alt="selectedImage"
                                                                                    style={{ width: '100%', }}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                    <div className='custom-upload-btn'>
                                                                        <Form.Label className={`btn btn-colr-white w-100`}>
                                                                            Add photo
                                                                        </Form.Label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Camera Modal */}
                                    <CameraModal
                                        show={showModal}
                                        handleClose={handleCloseModal}
                                        setPhotoInBox={updatePhotoInBox}
                                        ironId={iron == "iron1" ? "1" : (iron == "iron2" ? "2" : (iron == "iron3" ? "3" : ""))}
                                        ironTitle={title}
                                        
                                    />
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >


        </>
    );
});

export default IronsDatacamera;
